import { Pipe, PipeTransform } from '@angular/core';

import { FilterService } from "../services/filter.service";

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  constructor(
    private _filterService: FilterService
  ){}
  
  transform(value: any, args: any, attr: string[]): any {
    var arrayFiltered = this._filterService.filterArray(value, args, attr);
    return arrayFiltered;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/filter.pipe.ts
 **/